import { MD5 } from 'crypto-js'
import { v4 as uuid } from 'uuid'

import { CookieUtils } from './cookie'
import UserAgent from './userAgent'

export enum MIN_APP_VERSION {
  DEFAULT = '6.3.0',

  ONESTORE_PURCHASE = '6.2.0',
  ONESTORE_PAYMENT_STATE = '5.6.0',
  APPSFLYER = '6.4.0',
  GOOGLE_IAP = '6.4.2',
  GOOGLE_IAP_V2 = '7.4.0',
}

export enum VUE_APP_MODE {
  DEV = 'DEV',
  QA = 'QA',
  QA_LIVE = 'QA-LIVE',
  STAGE = 'STAGE',
  PRODUCTION = 'PRODUCTION',
}

const UUID_VERSION = 'V04'
const cookieEnabledYN = () => (window.navigator.cookieEnabled ? 'Y' : 'N')
// TODO :: SSR이슈로 useragent.init()은 project내에서 해야함
// const useragent = new UserAgent()
// useragent.init()

const getUrlQuery = (name: string) => {
  const q = window.location.search.match(new RegExp('[?&]' + name + '=([^&#]*)'))
  return q && q[1]
}

const getOsVersion = () => {
  return `${UserAgent.osName} ${UserAgent.osVersion}`
}

const getUncachedDeviceId = () => {
  const UUID: string = MD5(uuid()).toString()

  return `${UUID_VERSION}-${cookieEnabledYN()}-${UUID.substring(0, 8)}${UUID.substring(8, 4)}${UUID.substring(
    12,
    4,
  )}${UUID.substring(16, 4)}${UUID.substring(20, 12)}`.toUpperCase()
}

const setCachedDeviceId = (deviceId: string) => {
  if (cookieEnabledYN() === 'Y') {
    CookieUtils.set(CookieUtils.KEY.DEVICE_ID, deviceId)
  } else {
    console.log('flo.inc.js:setCachedDeviceId >> cookie is not available to set')
  }
}

const getCachedDeviceId = () => {
  return CookieUtils.get(CookieUtils.KEY.DEVICE_ID)
}

const isValidDeviceId = (deviceId?: string) => {
  return deviceId && deviceId !== '' && deviceId.indexOf(UUID_VERSION) === 0
}

const getDeviceId = () => {
  const cachedDeviceId: string | undefined = getUrlQuery('deviceId') || getCachedDeviceId()

  if (isValidDeviceId(cachedDeviceId)) {
    return cachedDeviceId
  } else {
    const deviceId = getUncachedDeviceId()
    setCachedDeviceId(deviceId)
    return deviceId
  }
}

const getOsInfo = () => {
  const appVersion = getUrlQuery('appVersion') || CookieUtils.get('appVersion') || MIN_APP_VERSION.DEFAULT
  const osType = getUrlQuery('osType') === 'I' ? 'IOS' : getUrlQuery('osType') === 'A' ? 'AOS' : 'WEB'
  const osVersion = getOsVersion()
  const browserName = UserAgent.browserName
  const browserVersion = UserAgent.browserVersion
  const osName = UserAgent.osName
  return {
    originInfo: {
      name: browserName,
      version: browserVersion,
      fullVersion: browserVersion,
      os: osName,
    },
    osModel: `${osName}_${browserName}`.replace(/ /g, '_'),
    osVersion,
    appVersion,
    osType,
  }
}

/**
 * @description FLO 기본 환경 상수 및 UTILS
 */
export const FLO = {
  CONFIG: {
    APP_NAME: () => (getOsInfo().osType === 'AOS' || getOsInfo().osType === 'IOS' ? 'FLO' : 'FLO_MWEB'),
    APP_VERSION: () => getOsInfo().appVersion, // FLO 모델이 변경될 경우마다 버전을 변경하자.
    APP_OS_TYPE: () => getOsInfo().osType,
    APP_OS_VERSION: () => getOsInfo().osVersion,
    APP_OS_MODEL: () => getOsInfo().osModel,
    VUE_APP_MODE,
  },
  UTILS: {
    isApp() {
      return CookieUtils.get(CookieUtils.KEY.IS_APP) === 'true'
    },
    isIosApp() {
      return CookieUtils.get(CookieUtils.KEY.OS_TYPE) === 'I'
    },
    isAosApp() {
      return CookieUtils.get(CookieUtils.KEY.OS_TYPE) === 'A'
    },
    isLocal: () => {
      return window.location.host.indexOf('music-flo.com') === -1
    },
    getDeviceId: () => {
      const mobileDeviceId = CookieUtils.get(CookieUtils.KEY.MOBILE_DEVICE_ID)
      if (mobileDeviceId) {
        return mobileDeviceId
      }
      return getDeviceId()
    },
    getOsInfo,
  },
}
